import { TextBox } from '@apply/components';
import { useExperienceAddressCity } from '../../../../fields/ExperienceFields';

interface ExperienceCityProps {
    experienceId: string | undefined;
    required?: boolean;
    readOnly?: boolean;
    validator?: React.ReactNode;
}

export const ExperienceCity: React.FC<ExperienceCityProps> = ({
    experienceId,
    required = false,
    readOnly = false,
    validator,
}) => {
    const label = 'City ';
    const [city, set_city] = useExperienceAddressCity(experienceId);

    return (
        <>
            <TextBox
                id='experienceCity'
                value={city}
                onChange={(value) => set_city(value)}
                label={label}
                required={required}
                width={'100%'}
                readOnly={readOnly}
                maxLength={50}
                validator={validator}
            />
        </>
    );
};
